import { Injectable, Optional, Host, SkipSelf, Component } from '@angular/core';
import { UtilityService } from './UtilityService';
import { CustomValidation } from '../Models/CustomValidation';
import { ErrorMassageValidation } from './validationErrorMassage.service';
import { ValidationErrors, ValidatorFn, AbstractControl, FormControl, Validators } from '@angular/forms';
import { InputType } from '../Enums/InputType';


@Injectable()
export class ControlUtility 
{
    constructor(private ErrorHandler: ErrorMassageValidation)
    {

    }

    getErrorValidation(Errorsitem: any[] ,CustomValidation?:CustomValidation): string {
        let resulte = '';
        Errorsitem.forEach(element => {
    
          if (element.key === 'customerError' && Errorsitem.length === 1) {
            resulte = CustomValidation[0].massage;
          } else if (element.key === 'EmailValidation') {
            resulte = element.value;
          } else if (element.key === 'FluentApi') {
            resulte = element.value;
          }
          else if (element.key === 'errorMassage') {
            resulte = element.value;
          }
          else {
            resulte = this.ErrorHandler.getErrorMassageValidation(element);
          }
        });
    
        return resulte;
      }
    
       patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
          if (!control.value) {
            return null;
          }
      
          const valid = regex.test(control.value);
         return valid ? null : error;
        };
      }
    
      getInputType(type: number):string
      {
        return InputType[type] as string
      }

      
      trimControlValue( value:any){
        const whitespace: string = ' ';
        if (value.startsWith(whitespace) || value.endsWith(whitespace)) {
        return value.trim();
        }
        else 
        return value
      }
    
      CopyInputMessage(inputElement)
      {
        inputElement.select();
        document.execCommand('copy');
        inputElement.setSelectionRange(0, 0);
      }

 
      getErrorValidationMassage(ErrorList,group,options) {
        // if((!group.valid)&&(!UtilityService.isCreatedBefor))
        // {
        //   UtilityService.showGlobalError();
        //   this.scrollToGlobalErrorMassage()
        // }
        return this.getErrorValidation(ErrorList,options.CustomValidation);
    }

    scrollToGlobalErrorMassage()
    {
      let element= document.getElementById('errorId');
      element.scrollIntoView({behavior: "smooth",  inline: "nearest"});
    }
    setAttributeForControl(options)
    {
      if(options.AttributeList!=null)
    {
      var element = document.getElementById(options.Name); 
       for (let index = 0; index < options.AttributeList.length; index++) {
        element.setAttribute(options.AttributeList[index].Key, options.AttributeList[index].value);
       }
    
    }

    }

    showGlobalError(){
      UtilityService.showGlobalError();
          this.scrollToGlobalErrorMassage()
  }

  RemoveRequiredValidation(FormControl: AbstractControl, ValidationRole: any[], Options: any) {
    Options.IsRequired = false
    ValidationRole = ValidationRole.filter((e) => e != Validators.required)
    FormControl.setValidators(ValidationRole);
    FormControl.updateValueAndValidity()
  }

  AddRequiredValidation(FormControl: AbstractControl, ValidationRole: any[], Options: any) {
    Options.IsRequired = true
    ValidationRole.push(Validators.required)
    FormControl.setValidators(ValidationRole);
    FormControl.updateValueAndValidity()
  }

  RemoveCustomValidation(FormControl: AbstractControl, ValidationRole: any[], CustomValidation:CustomValidation) {
    ValidationRole = ValidationRole.filter((e) => e !=CustomValidation.functionBody)
    FormControl.setValidators(ValidationRole);
    FormControl.updateValueAndValidity()
  }

  AddCustomValidation(FormControl: AbstractControl, ValidationRole: any[], CustomValidation:CustomValidation) {
    ValidationRole.push(CustomValidation.functionBody)
    FormControl.setValidators(ValidationRole);
    FormControl.updateValueAndValidity()
  }


 
  IsValid (FormControl: AbstractControl) {

    FormControl.markAsTouched();
  }

    
}
